<script>
    import Pager from './Pager.svelte'
    import SearchFilter from './SearchFilter.svelte'

    export let model
    export let record
    export let url
    let pagerURL = url

    $: items = record && record.items

    function pageChanged(newRecord) {
        record = newRecord
    }

    function filterApplied(newURL, newRecord) {
        pagerURL = newURL
        record = newRecord
    }
</script>

{#if items && items.length}
    <section id="linked_objects" class="subrecord-form-dummy">
        <h3 class="subrecord-form-heading">Objecten</h3>
        <div class="subrecord-form-container">
            <div class="subrecord-form-fields embedded-search">
                <div class="row">
                    <div class="col-md-3">
                        <div class="sidebar">
                            <SearchFilter
                                {filterApplied}
                                {url}
                                facets={record.facets}
                            />
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div class="record-pane">
                            <h2>{model.title}</h2>
                            <div class="pull-left">
                                Showing
                                <strong>{record.pager.cursor + 1}</strong>
                                -
                                <strong
                                    >{Math.min(
                                        record.pager.cursor +
                                            record.pager.limit,
                                        record.pager.total
                                    )}</strong
                                >
                                van
                                <strong>{record.pager.total}</strong>
                                resultaten
                            </div>
                            <table
                                id="tabledSearchResults"
                                class="table table-striped table-bordered table-condensed table-hover table-sortable table-search-results"
                            >
                                <thead>
                                    <tr>
                                        {#each model.columns as column}
                                            <th>
                                                {#if column.label}
                                                    {column.label}
                                                {/if}
                                            </th>
                                        {/each}
                                    </tr>
                                </thead>
                                <tbody>
                                    {#each items as item}
                                        <tr>
                                            {#each model.columns as column}
                                                <td>
                                                    {#if item[column.field]}
                                                        {item[column.field]}
                                                    {/if}
                                                </td>
                                            {/each}
                                            {#if item.editLink || item.viewLink}
                                                <td
                                                    class="col actions table-record-actions"
                                                >
                                                    <div class="btn-group">
                                                        {#if item.viewLink}
                                                            <a
                                                                class="btn btn-xs btn-default"
                                                                target="_blank"
                                                                href={item.viewLink}
                                                                >Bekijk
                                                            </a>
                                                        {/if}
                                                        {#if item.editLink}
                                                            <a
                                                                class="btn btn-xs btn-primary"
                                                                target="_blank"
                                                                href={item.editLink}
                                                                >Bewerk
                                                            </a>
                                                        {/if}
                                                    </div>
                                                </td>
                                            {/if}
                                        </tr>
                                    {/each}
                                </tbody>
                            </table>
                            <Pager
                                url={pagerURL}
                                {pageChanged}
                                pager={record.pager}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
{:else}
    <section id="linked_objects" class="subrecord-form-dummy">
        <h3 class="subrecord-form-heading">Objecten</h3>
        <p class="alert alert-info">Geen resultaten</p>
    </section>
{/if}
